import { createRaster, type Raster } from '@repo/warp-engine';

/** 면적 평균(box filter)으로 줄인다. 확대에는 쓰지 않는다. */
export const resizeRaster = (src: Raster, width: number, height: number): Raster => {
  const out = createRaster(width, height);
  const sx = src.width / width;
  const sy = src.height / height;
  for (let y = 0; y < height; y += 1) {
    const y0 = Math.floor(y * sy);
    const y1 = Math.max(y0 + 1, Math.floor((y + 1) * sy));
    for (let x = 0; x < width; x += 1) {
      const x0 = Math.floor(x * sx);
      const x1 = Math.max(x0 + 1, Math.floor((x + 1) * sx));
      let r = 0;
      let g = 0;
      let b = 0;
      let a = 0;
      let n = 0;
      for (let yy = y0; yy < y1 && yy < src.height; yy += 1) {
        for (let xx = x0; xx < x1 && xx < src.width; xx += 1) {
          const o = (yy * src.width + xx) * 4;
          const alpha = src.data[o + 3] ?? 0;
          r += (src.data[o] ?? 0) * alpha;
          g += (src.data[o + 1] ?? 0) * alpha;
          b += (src.data[o + 2] ?? 0) * alpha;
          a += alpha;
          n += 1;
        }
      }
      const d = (y * width + x) * 4;
      if (a > 0) {
        out.data[d] = Math.round(r / a);
        out.data[d + 1] = Math.round(g / a);
        out.data[d + 2] = Math.round(b / a);
        out.data[d + 3] = Math.round(a / n);
      }
    }
  }
  return out;
};

export interface FittedSize {
  readonly width: number;
  readonly height: number;
  readonly scale: number;
}

/** 픽셀 수 상한 안으로 비율을 유지해 줄인 크기. 상한 안이면 그대로(scale 1). */
export const fitWithinPixels = (width: number, height: number, maxPixels: number): FittedSize => {
  const pixels = width * height;
  if (pixels <= maxPixels) return { width, height, scale: 1 };
  const scale = Math.sqrt(maxPixels / pixels);
  return {
    width: Math.max(1, Math.floor(width * scale)),
    height: Math.max(1, Math.floor(height * scale)),
    scale,
  };
};
